import React from 'react';
import { services } from '../mock';
import * as LucideIcons from 'lucide-react';
import { Card } from './ui/card';
import './Services.css';

const Services = () => {
  const getIcon = (iconName) => {
    const iconMap = {
      'building-2': LucideIcons.Building2,
      'briefcase': LucideIcons.Briefcase,
      'search': LucideIcons.Search,
      'globe': LucideIcons.Globe
    };
    const Icon = iconMap[iconName] || LucideIcons.Circle;
    return <Icon size={40} />;
  };

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <span className="section-label">Services</span>
          <h2 className="section-title">Comprehensive Government Relations & Advisory</h2>
          <p className="section-description">
            Strategic solutions for navigating complex regulatory landscapes and achieving policy objectives
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <Card key={service.id} className="service-card">
              <div className="service-icon">{getIcon(service.icon)}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index} className="service-feature">
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
